import React from 'react'

import { DESIGN_SYSTEM_THEME } from '../../../constants/config'

import { ErrorImageProsperia } from './ErrorImageProsperia'

export const ErrorImage: React.FC<{ size?: number }> = ({ size = 160 }) => {
  switch (DESIGN_SYSTEM_THEME) {
    case 'prosperia':
      return <ErrorImageProsperia size={size} />
    default:
      return <ErrorImageProsperia size={size} />
  }
}
